import React from 'react';
import { Grid } from '@mui/material';

import DocumentLibraryIcon from '../../../assets/svg/signup/document_library.svg?react';
import DocumentSignIcon from '../../../assets/svg/signup/document_sign.svg?react';
import DocumentVaultIcon from '../../../assets/svg/signup/document_vault.svg?react';
import CRMIcon from '../../../assets/svg/signup/CRM_made_simple.svg?react';
import IntegratedAiIcon from '../../../assets/svg/signup/integrated_AI.svg?react';
import FeatureItem from '../feature-item/feature-item';

const FEATURES_LIST = [
  {
    id: 'docLibraryTitle',
    labelText: 'docLibraryTitle',
    description: 'docLibraryDescription',
    icon: <DocumentLibraryIcon />,
  },
  {
    id: 'docSignTitle',
    labelText: 'docSignTitle',
    description: 'docSignDescription',
    icon: <DocumentSignIcon />,
  },
  {
    id: 'docVaultTitle',
    labelText: 'docVaultTitle',
    description: 'docVaultDescription',
    icon: <DocumentVaultIcon />,
  },
  {
    id: 'crmTitle',
    labelText: 'crmTitle',
    description: 'crmDescription',
    icon: <CRMIcon />,
  },
  {
    id: 'integratedAiTitle',
    labelText: 'integratedAiTitle',
    description: 'integratedAiDescription',
    icon: <IntegratedAiIcon />,
  },
];

const FeatureItems = () => {
  return (
    <Grid
      component='div'
      container
      spacing={4}
      className='feature-items'
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {FEATURES_LIST.map((featureItem) => (
        <FeatureItem
          key={featureItem.id}
          icon={featureItem.icon}
          labelText={featureItem.labelText}
          description={featureItem.description}
        />
      ))}
    </Grid>
  );
};

export default FeatureItems;
